import LibPhoneNumber from 'google-libphonenumber'

const phoneNumberUtil = LibPhoneNumber.PhoneNumberUtil.getInstance()

const parseAndValidatePhoneNumber = (phoneNumber, region) => {
  try {
    const parsedPhoneNumber = phoneNumberUtil.parseAndKeepRawInput(phoneNumber, region)
    if (parsedPhoneNumber && phoneNumberUtil.isValidNumberForRegion(parsedPhoneNumber, region)) {
      return parsedPhoneNumber
    }
  } catch (_) {
    // Do nothing and return null
  }
  return null
}

export const formatPhoneNumber = (phoneNumber, region, e164 = false) => {
  const parsedPhoneNumber = parseAndValidatePhoneNumber(phoneNumber, region)
  if (!parsedPhoneNumber) {
    return null
  }

  return phoneNumberUtil.format(
    parsedPhoneNumber,
    e164 ? LibPhoneNumber.PhoneNumberFormat.E164 : LibPhoneNumber.PhoneNumberFormat.INTERNATIONAL,
  )
}

export const validatePhoneNumber = (phoneNumber, region) => {
  const parsedPhoneNumber = parseAndValidatePhoneNumber(phoneNumber, region)
  return !!parsedPhoneNumber
}
